import { createSlice } from '@reduxjs/toolkit';

export const companySlice = createSlice({
	name: 'companyInfo',
	initialState: {},
	reducers: {
		// Get Company Info List
		setCOMRequestStatus: (state, action) => {
			state.isCOMRequestStatusUpdated = action.payload;
		},

		// Get Company Info List
		getCompanyInfoList_requesting: (state) => {
			state.getCompanyInfoList_requesting = true;

			state.companyInfoList = undefined;
			state.companyInfoListHeaders = undefined;
		},
		getCompanyInfoList_success: (state, action) => {
			state.getCompanyInfoList_requesting = false;
			state.companyInfoList = action.payload.data;
			state.companyInfoListHeaders = action.payload.headers;
		},
		getCompanyInfoList_failure: (state) => {
			state.getCompanyInfoList_requesting = false;
		},

		// Get All Company Info List
		getAllCompanyInfoList_requesting: (state) => {
			state.getAllCompanyInfoList_requesting = true;

			state.allCompanyInfoList = undefined;
			state.allCompanyInfoListHeaders = undefined;
		},
		getAllCompanyInfoList_success: (state, action) => {
			state.getAllCompanyInfoList_requesting = false;
			state.allCompanyInfoList = action.payload.data;
			state.allCompanyInfoListHeaders = action.payload.headers;
		},
		getAllCompanyInfoList_failure: (state) => {
			state.getAllCompanyInfoList_requesting = false;
		},

		// Get Company Info Option Lists
		getCompanyInfoOptionLists_requesting: (state) => {
			state.getCompanyInfoOptionLists_requesting = true;
		},
		getCompanyInfoOptionLists_success: (state, action) => {
			state.getCompanyInfoOptionLists_requesting = false;
			state.companyInfoOptionLists = action.payload.data;
		},
		getCompanyInfoOptionLists_failure: (state) => {
			state.getCompanyInfoOptionLists_requesting = false;
		},
	},
});

export const { 
	setCOMRequestStatus, 

	getCompanyInfoList_requesting, 
	getCompanyInfoList_success,
	getCompanyInfoList_failure,

	getAllCompanyInfoList_requesting,
	getAllCompanyInfoList_success,
	getAllCompanyInfoList_failure,

	getCompanyInfoOptionLists_requesting,
	getCompanyInfoOptionLists_success,
	getCompanyInfoOptionLists_failure
} = companySlice.actions;

export default companySlice.reducer;